import React from "react"
import { Modal } from "react-bootstrap"
import ReactPlayer from "react-player";
import PlayIcon from "../images/play-icon-light.png";
import PauseIcon from "../images/pause-icon.png";

const VideoPopup = props => {
  const [playing, setPlaying] = React.useState(true);
  const [startVideo, setStartVideo] = React.useState(true);

  const playerRef = React.useRef();

  const handledOnEnded = React.useCallback(() => {
    playerRef.current.showPreview();
    setStartVideo(false);
  }, []);

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <div className="position-relative d-flex justify-content-center align-items-center w-100 video-section" >
      <ReactPlayer
        url={props.videoId}
        className="home-video"
        playing={playing}
        width={"100%"}
        height={"100%"}
        style={{borderRadius: 14}}
        onEnded={() => handledOnEnded()}
        ref={playerRef}
        controls={true}
        onPlay={(e) => { setPlaying(true); setStartVideo(true); }}
        onPause={(e) => { setPlaying(false); setStartVideo(false); }}
      />
       {!playing && !startVideo && <img src={PlayIcon} className="play-icon position-absolute" onClick={() =>  { setPlaying(!playing); setStartVideo(!startVideo); } } />}
       {playing && startVideo && <img src={PauseIcon} className="pause-icon position-absolute" onClick={() => { setPlaying(!playing); setStartVideo(!startVideo); }} />}
       </div>
    </Modal>
  )
}

export default VideoPopup
